var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFulltiltMobile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 28,
    viewBox: "0 0 39 28",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "path-1",
    d: "M.167.005h4.81V6.08H.166z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-3",
    d: "M.198.005h4.808V6.08H.198z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-5",
    d: "M0 6.649h38.985v21.12H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Top-Navigation-/-Small-/-Full-Tilt",
    transform: "translate(-31 -2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(31 2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.09 5.987l.103-.271h.1v.369h-.065v-.3h-.002l-.116.3h-.044l-.115-.3h-.003v.3h-.065v-.369h.1l.106.271zm-.271-.217h-.114v.315h-.065V5.77h-.114v-.054h.293v.054z",
    id: "Fill-1",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-2",
    fill: "#A92227",
    d: "M1.33 8.714H37.22l-22.067 18.01z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-3",
    fill: "#FFF",
    d: "M7.244.013L6.5 6.08h2.249l.286-2.329h3.055l.16-1.305H9.197l.133-1.091h3.392l.165-1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.792.013h2.068l-.465 3.79c-.032.257-.055.523.173.73.16.162.426.223.689.223.354 0 .6-.112.743-.215.289-.215.331-.481.363-.739l.465-3.789h2.078l-.397 3.23c-.085.697-.196 1.599-1.117 2.277-.566.413-1.238.722-2.338.722-1.05 0-1.729-.292-2.2-.722-.636-.584-.563-1.262-.505-1.898l.443-3.609z",
    id: "Fill-4",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(20.132)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Fill-6",
    fill: "#FFF",
    d: "M.913.005h2.252L2.607 4.55h2.37l-.189 1.529H.168z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-11",
    transform: "translate(25.686)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Fill-9",
    fill: "#FFF",
    d: "M.944.005h2.251L2.637 4.55h2.369l-.187 1.529H.199z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M31.311 5.933c-.012.056-.054.092-.106.092-.077 0-.127-.058-.127-.133 0-.076.048-.131.125-.131.054 0 .099.03.107.089h-.037c-.007-.031-.034-.052-.07-.052-.053 0-.082.04-.082.094 0 .051.032.096.084.096.036 0 .062-.023.068-.055h.038zm-.114.14a.174.174 0 00.175-.18.174.174 0 00-.175-.179.174.174 0 00-.175.179c0 .104.076.18.175.18zm-.219-.18c0-.123.1-.215.22-.215.117 0 .217.092.217.215 0 .125-.1.216-.218.216a.215.215 0 01-.219-.216z",
    id: "Fill-12",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-14",
    fill: "#FFF",
    d: "M19.17 12.192l.356-3.332L2.202 12l-.353 3.263L9.42 13.94l-.768 9.614 3.961-.733.937-9.627z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-16",
    fill: "#FFF",
    d: "M15.84 14.717l-.815 7.691 3.2-.607.814-7.693z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-18",
    fill: "#FFF",
    d: "M21.237 8.545l-1.264 12.96 3.406-.63 1.295-12.958z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.835 19.833c-2.174.414-3.559-.216-3.407-2.289l.404-3.97-.557.102.26-2.755.593-.097.264-3.247 3.215-.552-.303 3.242 2.722-.546-.302 2.755-2.765.554-.273 2.801c-.057.775.45.808 1.053.692.172-.031.911-.217 1-.252l-.009 2.92c-.371.145-1.378.543-1.895.642",
    id: "Fill-20",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-6",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-5"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M29.955 6.649l-.401.068-3.214.553-.238.04-.02.242-.045.551h-1.068l.015-.155.042-.412-.408.074-2.699.493H0l.385.502 2.297 2.991-.536.097-.229.042-.025.231-.353 3.264-.044.412.407-.072 3.378-.59 3.392 4.416-.33 4.134-.033.405.4-.074 2.97-.55 3.226 4.202.196.256.25-.205 7.655-6.304.43-.078.23-.043.023-.234.022-.226 1.742-1.433c.323.526.963 1.018 2.227 1.018.367 0 .775-.042 1.213-.125.532-.102 1.504-.483 1.92-.646l.031-.012.197-.078.001-.212.008-2.92v-.46l-.427.17c-.085.03-.777.206-.94.235-.157.03-.28.045-.38.045-.09 0-.15-.01-.192-.027l9.204-7.578.67-.553H29.82l.098-1.05.038-.404zm-.348.376l-.13 1.39h8.64l-9.412 7.75c.07.308.298.407.597.407.134 0 .283-.02.437-.05.172-.03.911-.217 1-.251l-.008 2.92c-.372.145-1.379.543-1.896.642-.416.079-.802.12-1.155.12-1.066 0-1.82-.375-2.12-1.2l-2.146 1.768-.035.354-.509.093-7.718 6.355-3.343-4.353-3.157.585.34-4.253-3.58-4.662-3.563.624L2.202 12l1.038-.188L.632 8.415h21.315l2.727-.498-.05.498h1.7l.068-.838 3.215-.552z",
    id: "Fill-22",
    fill: "#2E2925"
  }))))));
}

SvgFulltiltMobile.displayName = 'FulltiltMobile';
export default SvgFulltiltMobile;